var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Brianna"),_c('br'),_vm._v("DelValle")]),_c('p',[_vm._v("I'll put something here eventually.")])])
}]

export { render, staticRenderFns }